import { api } from 'src/services';

import searchForUsers from './searchForUsers';
import getUserPermissions from './userPermissions';
import searchUsers from './searchUsers';
import getStadiumFollowers from './getStadiumFollowers';

export const authApis = api.injectEndpoints({
  endpoints: (build) => ({
    searchForUsers: searchForUsers(build),
    getUserPermissions: getUserPermissions(build),
    searchUsers: searchUsers(build),
    getStadiumFollowers: getStadiumFollowers(build),
  }),
  overrideExisting: true,
});

export const {
  useSearchForUsersMutation,
  useGetUserPermissionsMutation,
  useSearchUsersMutation,
  useLazyGetStadiumFollowersQuery,
} = authApis;
